/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

const bd_center_service = async (p: any, store: any) => {
  const resp = await http.post(
    '/live/hiya_socialize/bd_center',
    {
      ...p,
    },
    {
      store,
      xcErrorToast: true,
    }
  )
  return resp.data.data
}

export const bd_center_tab1 = createAsyncThunk(
  'Saada/saadaBdCenter/bd_center_tab1',
  bd_center_service
)
export const bd_center_tab2 = createAsyncThunk(
  'Saada/saadaBdCenter/bd_center_tab2',
  bd_center_service
)

export const get_member_info_by_show_id = createAsyncThunk(
  'Saada/saadaBdCenter/get_member_info_by_show_id',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/account/get_member_info_by_show_id',
      {
        ...p,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const union_invite = createAsyncThunk(
  'Saada/saadaBdCenter/union_invite',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/union_invite',
      {
        ...p,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 定义邀请状态的类型
type InviteStatus = 0 | 1 | 2 | 3 | 4
// 定义性别类型
type Gender = 1 | 2
// 定义结算结果原因类型
type BdSettleResultReason = 0 | 1

// 邀请列表项类型
interface InviteItem {
  id: number
  gender: Gender
  avatar: string
  name: string
  time: string
  status: InviteStatus
}

// 联盟列表项类型
interface UnionItem {
  id: number
  gender: Gender
  avatar: string
  name: string
  time: string
  host_num: number
  income: number
  bd_income: number
  expire_date: string
}

// 主数据类型
interface InitialStateType {
  rules: {
    introduction: string[]
    rewards: {
      pearl: string
      ratio: string
      virtual_rewards: {icon: string; desc: string}[]
    }[]
  }
  invite_list: InviteItem[]
  time_ranges: string[]
  expectation_income: number
  union_list: UnionItem[]
  bd_settle_result_reason: BdSettleResultReason
}
const initialState: Partial<InitialStateType> = {}

export function useBDCenter() {
  return useSelector((store) => store.SaadaBDCenter)
}

export const SaadaBDCenterSlice = createSlice({
  name: 'SaadaBDCenter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(bd_center_tab1.fulfilled, (state, action) => {
      const {union_list, expectation_income, ...rest} = action.payload
      Object.assign(state, rest)
    })
    builder.addCase(bd_center_tab2.fulfilled, (state, action) => {
      const {invite_list, ...rest} = action.payload
      Object.assign(state, rest)
    })
  },
})

export default SaadaBDCenterSlice.reducer
export const SaadaBDCenterActions = SaadaBDCenterSlice.actions
